<template >
    <div class="container-fluid" v-if="lesson">
      <h1 class="text-center">{{lesson.name}}</h1>
      <p>{{lesson.description}}</p>
      <p v-if="lesson.numberOfTopics">Сэдвийн тоо: {{lesson.numberOfTopics}}</p>
       <div v-if="lesson.files!=null && lesson.files.length>0" class="py-5">
           <h4>Хичээлийн файлууд</h4>
        <ul class="list-group">
          <li class="list-group-item" v-for="(file) in lesson.files" v-bind:key="file.id">
            {{file.title}}

            <a class="btn btn-sm btn-success" v-bind:href="file.fileUrl" target="_blank">татах</a>
          </li>
        </ul>
      </div>

      <div class="card  shadow mb-4">   
        <div class="card-header row">
          <div class='col'>
            <h4 class="text-center">Нэмэлт мэдээлэл</h4>
          </div>
          <div class="col col-auto">
            <h3 v-if="lesson.published==true" ><span class="badge badge-success">Нээлттэй</span></h3>
            <h3 v-else><span class="badge badge-danger">Хаалттай</span></h3>
          </div>
        </div>  
        <div class="card-body"> 
          <div class="row  text-center text-lg-left mt-5" v-if="lesson.images!=null && lesson.images.length>0">
            <div class="col-lg-3 col-md-4 col-6" v-for="(file) in lesson.images" v-bind:key="file.fileUrl">
                <a href="#" class="d-block mb-4 h-100">
                <img class="img-fluid" :src="file.fileUrl" />
                </a>
            </div>
          </div>
          <div class="my-4"  v-if="lesson.results!=null && lesson.results.length>0">
            <h3>Зорилго</h3>
            <ul >
              <li v-for="(include) in lesson.results" v-bind:key="include">{{include}}</li>
            </ul>
          </div>
          <div class="my-4" v-if="lesson.requirements!=null && lesson.requirements.length>0">
            <h3>Шаардлагууд</h3>
            <ul >
              <li v-for="(include) in lesson.requirements" v-bind:key="include">{{include}}</li>
            </ul>
          </div>
          <div class="my-4" v-if="lesson.whatlearned!=null && lesson.whatlearned.length>0">
            <h3>Эзэмшүүлэх мэдлэг</h3>
            <ul >
              <li v-for="(include) in lesson.whatlearned" v-bind:key="include">{{include}}</li>
            </ul>
          </div>
          
      
          <div class="my-4"  v-if="lesson.handlaga!=null && lesson.handlaga.length>0">
            <h3>Хичээлээр эзэмшүүлэх хувь хүний ур чадвар, хандлага</h3>
            <ul >
              <li v-for="(include) in lesson.handlaga" v-bind:key="include">{{include}}</li>
            </ul>
          </div>

        </div>
      </div>
   
      
      <div v-if="topics!=null && topics.length>0" class="card shadow mb-4" v-for="(topic) in topics" v-bind:key="topic.id" >
        <div class="card-header py-3">
          <h3 class="m-0 font-weight-bold text-primary">{{topic.name}}</h3>
          <p>{{topic.description}}</p>

        </div>
        <div class="card-body" >
          <div class="list-group">
            <div v-for="(item, index) in topic.details" v-bind:key="item.id"  class="list-group-item list-group-item-action flex-column align-items-start ">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{index+1}}. {{item.name}}</h5>
                <small v-if="item.type!=null && item.type!=undefined">{{item.type}}</small>
              </div>
              <p class="mb-1">{{item.description}}</p>
              <ul>
                <li style="margin-bottom: 18px;" v-if="item.videoUrl!=null">
                  <a v-bind:href="item.videoUrl" target="blank">  {{ item.videoUrl }} </a>
                     <br/>

                  <iframe width="560" height="315" v-if="item.videoUrl!=null && item.videoUrl!='' && item.videoUrl.toLowerCase().indexOf('youtube') != -1" v-bind:src="getYoutubeIframe(item.videoUrl)"  frameborder="0" allowfullscreen></iframe>
                
                </li>
                <!-- <br/> -->
                <li v-if="item.files!=null && item.files.length>0">
                  <div >
                      <div v-for="(file, index) in item.files" v-bind:key="file.id" >
                        <a v-bind:href="file.fileUrl" target="_blank" v-if="validFile(file)"><i class="fas fa-download"></i> {{file.fileName}}</a>
                      </div>
                  </div>
                </li>
              </ul>
      

            </div>
           
          </div>
        </div>
      </div>

      <div v-else class="alert alert-warning">
        <p>Одоогоор хичээлийн сэдэв оруулаагүй байна.</p>
      </div>

    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
export default {
    name: "LessonDetailPublic",
    data() {
        return {
            lesson: null,
            topic:{
              'name':null,
              'description':null
            },
            topics:[],
            types:[],
            selectedType:null
            
        };
    },
    methods: {
      validFile(file){
        if(file.fileName.endsWith("mp4") 
            || file.fileName.endsWith("MP4") 
            || file.fileName.endsWith("MPEG") 
            || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
            || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
          ){
            return false;
        }
        return true;
      },
        
      _getQA(){

          fb.db.collection("lessons").doc(this.lessonId).onSnapshot(doc=> {
              let lesson=doc.data()
              lesson.id=doc.id
              this.lesson=lesson;
            
          });
          if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
            // fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).onSnapshot(stdDoc=> {
              this.topics=[];
              // if(stdDoc.exists && stdDoc.data().enabled==true){
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").orderBy("createdAt","desc").get().then(querySnapshot=> {
                  
                  querySnapshot.forEach(doc=> {
                    let object=doc.data()
                    object.id = doc.id;
                    object.details=[];
                    doc.ref.collection("details").orderBy("createdAt").get().then(contentSnapshot=> {
                      object.details=[];
                      contentSnapshot.forEach(contentDoc=> {
                        let content=contentDoc.data()
                        content.id = contentDoc.id;
                        content.uploading=false
                        content.uploadPercent=0
                        object.details.push(content);
                      });
                      
                    });
                    this.topics.push(object);
                  });
                  
                });
            //   }
            // });
            
            
          }

      },
      getYoutubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);

          return (match && match[2].length === 11)
            ? match[2]
            : null;
      },
      getYoutubeIframe(url){
        if(url!=null && url!='' && url.toLowerCase().indexOf("youtube") != -1){
          var id= this.getYoutubeId(url);
          return 'https://www.youtube.com/embed/' + id ;
        }
        return null;
      },
      hasWhiteSpace(s) {
        return /\s/g.test(s);
      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
  
};
</script>

